<!-- <div class="user-panel">
    <div class="user-info">
        <div class="image-container">
            <div class="user-image" [style.background-image]="'url(' + getIMG + ')'">
            </div>
        </div>
        <div class="user-name">
            {{add3Dots(this.getAuthInfo[0].consultantName,10)}}
        </div>
    </div>
    <dx-context-menu *ngIf="menuMode === 'context'" [items]="menuItems" target=".user-button" showEvent="dxclick"
        width="170px" [position]="{ my: 'top center', at: 'bottom center' }" cssClass="user-menu">
    </dx-context-menu>
    <dx-list *ngIf="menuMode === 'list'" class="dx-toolbar-menu-action" [items]="menuItems">
    </dx-list>
</div> -->


<!-- <div class="btn-group d-block w-100" *ngIf="0">
    <div class="user-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div class="image-container">
            <div class="user-image" [style.background-image]="'url(' + getIMG + ')'"> </div>
        </div>
        <div class="user-name">
            {{add3Dots(this.getAuthInfo[0].consultantName,13)}}
        </div>
    </div>

    <div class="dropdown-menu dropdown-menu-right shadow-sm radius-10 cmenu">
        <button *ngIf="getAuthInfo[0].restrictEmpLogin !==1" class="dropdown-item" type="button"
            (click)="fnResetPassword()">
            <span class="borderLeft d-flex align-items-center">
                <img src="assets/Web Icon/Black/Change Password.png" alt="Password" class="image-dark">
                <img src="assets/Web Icon/Black/Change Password.png" class="image-white" alt="Password">
                <span class="pl-3">Change Password</span>
            </span>
        </button>
        <button class="dropdown-item" type="button" (click)="fnLogOut()">
            <span class="borderLeft d-flex align-items-center">
                <img src="assets/Web Icon/Black/Log Out.png" alt="Logout" class="image-dark">
                <img src="assets/Web Icon/Black/Log Out.png" alt="Logout" class="image-white">
                <span class="pl-3">Logout</span>
            </span>
        </button>
    </div>
</div> -->

<li class="nav-item dropdown d-flex align-items-center">
    <a class="nav-link user-info dropdown-toggle no-arrow p-0" href="#" id="profile" role="button"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div class="image-container">
            <div class="user-image" [style.background-image]="'url(' + getIMG + ')'"> </div>
        </div>
        <div class="user-name">{{add3Dots(this.getAuthInfo[0].consultantName,13)}}</div>
    </a>

    <div class="dropdown-menu dropdown-menu-right mt-3" aria-labelledby="Profile">
        <div class="px-2">
            <span class="sub-menu fs-16">{{this.getAuthInfo[0].consultantName}}</span><br>
            <span class="sub-menu fs-14">{{this.getAuthInfo[0].eMailID}}</span>
        </div>
        <div class="dropdown-divider"></div>
        <a data-toggle="tooltip" data-placement="right" title="Change Password"
            class="dropdown-item d-flex align-items-center nav-item nav-link text-nowrap"
            *ngIf="getAuthInfo[0].restrictEmpLogin !==1 && isShowChangePassword" (click)="fnResetPassword()">
            <i class="fs-18 mr-4 fas fa-key"></i>
            <span class="sub-menu fs-16">Change Password</span>
        </a>
        <a data-toggle="tooltip" data-placement="right" title="Change Password"
            class="dropdown-item d-flex align-items-center nav-item nav-link text-nowrap" (click)="fnOpenHelpDocs()">
            <i class="fs-18 mr-4 fas fa-question"></i>
            <span class="sub-menu fs-16">Help</span>
        </a>
        <a data-toggle="tooltip" id="logOut" title="Logout"
            class="dropdown-item d-flex align-items-center nav-item nav-link text-nowrap" (click)="fnLogOut()">
            <i class="fs-18 mr-4 fas fa-sign-out-alt"></i>
            <span class="sub-menu fs-16">Logout</span>
        </a>
    </div>
</li>